import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Images, Upload, Settings, LogOut } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';

const BottomNav = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const navItems = [
    { to: '/gallery', icon: Images, label: 'Gallery' },
    { to: '/upload', icon: Upload, label: 'Upload' },
  ];

  if (isAdmin) {
    navItems.push({ to: '/admin', icon: Settings, label: 'Admin' });
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-100 safe-area-bottom z-50">
      <div className="max-w-md mx-auto flex items-center justify-around h-16">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`nav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-4 py-2 rounded-xl transition-colors ${
                isActive
                  ? 'text-violet-600'
                  : 'text-slate-400 hover:text-slate-600'
              }`
            }
          >
            <Icon className="w-6 h-6" strokeWidth={1.5} />
            <span className="text-xs font-medium">{label}</span>
          </NavLink>
        ))}

        {/* Profile Menu */}
        <DropdownMenu>
          <DropdownMenuTrigger 
            data-testid="profile-menu-trigger"
            className="flex flex-col items-center gap-1 px-4 py-2 rounded-xl text-slate-400 hover:text-slate-600 transition-colors"
          >
            <div className="w-6 h-6 bg-violet-100 rounded-full flex items-center justify-center">
              <span className="text-xs font-semibold text-violet-700">
                {user?.name?.charAt(0)?.toUpperCase()}
              </span>
            </div>
            <span className="text-xs font-medium">Profile</span>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48 rounded-xl">
            <div className="px-3 py-2">
              <p className="font-medium text-slate-900">{user?.name}</p>
              <p className="text-sm text-slate-500">{user?.phone}</p>
            </div>
            <DropdownMenuSeparator />
            <DropdownMenuItem 
              data-testid="logout-btn"
              onClick={handleLogout}
              className="text-red-600 cursor-pointer"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Sign Out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </nav>
  );
};

export default BottomNav;
